export default __webpack_public_path__ + "static/media/iPhone-Premium-5.0008b634.png";